<script>
    import {push, pop, replace} from 'svelte-spa-router'
	import { fade } from 'svelte/transition';
	import Header from './Header.svelte';
	import { springIn } from "svelte-helpers/spring-transitions";
	import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
    import { Line } from 'svelte-chartjs'
	import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale } from 'chart.js';
	import Modal, { bind } from 'svelte-simple-modal';
    import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	import Switch from './Switch.svelte';

    const modal = writable(null);

	ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale);

	let data_1 = {
        labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
  datasets: [
    {
      label: 'Watts',
      fill: true,
      lineTension: 0.3,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      borderColor: 'rgb(114, 92, 216)',
      borderCapStyle: 'butt',
      borderDash: [],
	  borderWidth: 2,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
	  pointRadius: 0,
      data: [50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50],
    },
  ],
};

    let data_2 = {
        labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
  datasets: [
    {
      label: 'Watts',
      fill: true,
      lineTension: 0.3,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      borderColor: 'hsl(185, 97%, 75%)',
      borderCapStyle: 'butt',
      borderDash: [],
	  borderWidth: 2,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
	  pointRadius: 0,
      data: [50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50],
    },
  ],
};

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    // The params prop contains values matched from the URL
    export let params = {}

    let dash_token = params.t
    if (dash_token != '1') {
		if (getCookie("m_dash_token") != '') {
			dash_token = getCookie("m_dash_token")
		} else{
            dash_token = '1';
        }
	}

	let owner_mebot_id = params.id
    if (getCookie('m_id') != '') {
      owner_mebot_id = getCookie('m_id');
    }

	let enemy_mebot_id = params.m_id

    if (enemy_mebot_id == owner_mebot_id) {
        enemy_mebot_id = params.id
    }

    let result = null
    let mebot_img_url = null;
    let enemy_img_url = null;
    let mebot_img_url_tmp = null;
    let mebot = [];
    let enemy_mebot = [];
    let number = 0;
    let start_time = 0;
    let diff_time = 0;
    let battle_finished = false;
    let show_players = false;
    let winner = 0;
    let owner_punch = false;
    let enemy_punch = false;
    let full_loaded = false;
    let dice_me = Math.floor(Math.random() * 6 + 1);
    let dice_enemy = Math.floor(Math.random() * 6 + 1);
	let time_remaining = 0;
	let play_time = 0;
    let won_id = 0;
    let winnings = 0;
    let enemy_watt_level = 0;
    let balance = 0;
    let factor = 1;
    let energy_factor = 1;
    let prize = 0;
    let mebot_dp = 100;
    let mebot_cur_dp = 0;
    let rand_time = 1;
    let energy_used = 0;
    let enemy_score = 0;
    let me_score = 0;
    let me_dice = 0;
    let enemy_dice = 0;
    let enemy_arts = 0;
    let me_arts = 0;
    let has_ko = 0;

    let show_close = true;
	let timeout_id;
	let mebot_power = '';
    let mebot_power_enemy = '';
    let enemy_mp = 100;
    let no_energy = '';
    let display_loading = false;

    let me, me_rand;
    let enemy, enemy_rand;

    let auto_battle = false;
    $: auto_battle, saveAutobattle();

    let progress = tweened(1, {
        duration: 100,
        easing: cubicOut
    });

    let progress_enemy = tweened(1, {
        duration: enemy,
        easing: cubicOut
    });

    const daily_power = tweened(0, {
		duration: 400,
		easing: cubicOut
	});
    daily_power.set(1);

    const daily_power_enemy = tweened(0, {
		duration: 400,
		easing: cubicOut
	});
    daily_power_enemy.set(1);

    async function loadMebots() {

        await loadGame();
        await fetchMebotStats(owner_mebot_id);
        fetchMebotStats(enemy_mebot_id);
    }

    function decrementTimer() {
		if (time_remaining > 0) {
			time_remaining--;
		}
	}
    var intervalId = window.setInterval(function() {
		decrementTimer();
	}, 1000);

	async function fetchMebotStats (mebot_id = 0) {

        let stat_type = 1;

		const res = await fetch('https://api.forever.today/?method=get_mebot_stat', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
                stat_type
            })
		})

        const json = await res.json()
        result = json

        if (enemy_mebot_id == mebot_id) {
            enemy_mebot = json.data.mebot;
            enemy_img_url = enemy_mebot.mebot_f_img_url;

            await preloadImage(enemy_img_url);

            data_1.datasets[0].data = json.data.mebot.health;
        }
        if (owner_mebot_id == mebot_id) {
            mebot = json.data.mebot;
            mebot_img_url = mebot.mebot_img_url;
            mebot_img_url_tmp = mebot_img_url;
            data_2.datasets[0].data = json.data.mebot.health;

            await preloadImage(mebot_img_url_tmp);

            mebot_dp = mebot.dp;
            mebot_cur_dp = mebot_dp;
            mebot_power = mebot.mebot_power;

            daily_power.set(mebot_dp/100);
        }
		//liked = mebot.is_liked;

        if (mebot_id == enemy_mebot_id) {
            //start game
            enemy_watt_level = enemy_mebot.watt_level;
            if (enemy_watt_level == 0) {
                enemy_watt_level = 1;
            }
            restartGame()
        }
    }

    loadMebots();

    async function punchEnemy() {

        //if (!battle_finished) {
            enemy_punch = true;

            enemy = enemy - 10;
            //console.log(enemy)

            setTimeout(
                function() {
                    enemy_punch = false;
                },
                Math.floor(Math.random() * 500 + 1)
            );
        //}
    }

    async function punchMe() {

            owner_punch = true;
            setTimeout(
                function() {
                    owner_punch = false;
                },
                Math.floor(Math.random() * 500 + 1)
            );
    }

    async function loadGame() {

        console.log('loading')
        console.log('energy used: ' + energy_used)

        const res = await fetch('https://api.forever.today/?method=load_battle', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id: owner_mebot_id,
                enemy_mebot_id,
                won_id,
                energy_used
            })
		})

        won_id = 0;

        const json = await res.json()
        play_time = json.data.play_time_left;
		time_remaining = play_time;
        balance = json.data.balance;
        factor = json.data.factor;
        prize = json.data.prize;
        energy_factor = json.data.ef;
        console.log('energy factor: ' + energy_factor)
        no_energy = json.data.no_energy;
        mebot_power_enemy = json.data.mpe;
        enemy_mp = json.data.emp;

        enemy_score = json.data.enemy_score;
        me_score = json.data.me_score;

        enemy_arts = json.data.enemy_arts;
        me_arts = json.data.me_arts;

        //if ()
        me_dice = json.data.md;
        enemy_dice = json.data.ed;

        mebot_dp = json.data.dp;
        mebot_cur_dp = mebot_dp;
        if (time_remaining > 0) {

            if (enemy_mp > 1) {
                mebot_dp = 0;
                mebot_cur_dp = 0;
                daily_power.set(0);
            }
            if (enemy_mp <= 1) {
                enemy_mp = 0;
            }
        }
        if (json.data.mebot_power_str != '') {
          mebot_power = json.data.mebot_power_str;
        }
        energy_used = 0;
        has_ko = json.data.has_ko;

        setTimeout(function(){ daily_power_enemy.set(enemy_mp/100) }, 200);

        console.log('energy left ' + mebot_dp)
        console.log('loaded')
    }

    async function restartGame() {

        progress.set(1);
        progress_enemy.set(1);
        battle_finished = false;
        full_loaded = false;
        mebot_img_url = null;

        dice_me = Math.floor(Math.random() * 6 + 1);
        dice_enemy = Math.floor(Math.random() * 6 + 1);

        if (enemy_dice > 0) {
            dice_enemy = enemy_dice;
        }
        if (me_dice > 0) {
            dice_me = me_dice;
        }
    
        me_rand = Math.floor(Math.random() * 1000)
        //level*100 + fitness*10 + avg_14day_steps + dice_score 
        me = (mebot.watt_level)*200 + (mebot.fitness)*15 + (mebot.steps_14day_av)*10 + (dice_me)*350 + mebot.uhv + mebot.mood.p*2 + mebot_cur_dp*15;

        if (me_arts > 0) {
            console.log('me: (arts) ' + me_arts + ' + ' + me);
            me = me_arts + Math.floor(me)
        } else {
            me = 1000 + me_rand + Math.floor(me)
        }
        console.log('me: ' + me_rand + ' : ' + mebot.watt_level*200 + ' ' + mebot.fitness*15+ ' ' + Math.floor(mebot.steps_14day_av*10) + ' ' + dice_me*350 + ' ' + mebot.uhv + ' ' + mebot.mood.p*2 + ' :    ' + mebot_cur_dp*15);
        console.log('me (' + owner_mebot_id + '): ' + me)

        enemy_rand = Math.floor(Math.random() * 1000)
        enemy = (enemy_mebot.watt_level)*200 + (enemy_mebot.fitness)*15 + (enemy_mebot.steps_14day_av)*10 + (dice_enemy)*350 + enemy_mebot.uhv + enemy_mebot.mood.p*2 + enemy_mp*10;

        if (enemy_arts > 0) {
            console.log('ene: (arts) ' + enemy_arts + ' + ' + enemy);
            enemy = enemy_arts + Math.floor(enemy)
        } else {
            enemy = 1000 + enemy_rand + Math.floor(enemy)
        }
        console.log('ene: ' + enemy_rand + ' : ' + enemy_mebot.watt_level*200 + ' ' + enemy_mebot.fitness*15 + ' ' + enemy_mebot.steps_14day_av*10 + ' ' + dice_enemy*350 + ' ' + enemy_mebot.uhv + ' ' + enemy_mebot.mood.p*2 + ' :    ' + enemy_mp*10);
        console.log('ene (' + enemy_mebot_id + '): ' + enemy)

        if (enemy_score > 0) {
            enemy =  enemy_score;
        }
        if (me_score > 0) {
            me =  me_score;
        }
    
        progress = tweened(1, {
            duration: me,
            easing: cubicOut
        });

        progress_enemy = tweened(1, {
		    duration: enemy,
		    easing: cubicOut
	    });

        number = 0;
        if (!full_loaded) {
            full_loaded = true;
            console.log('show battle');
            mebot_img_url = mebot_img_url_tmp;
        }
        if (time_remaining == 0) {
            await sleep(100);
            doNothing();
        } else {
            battle_finished = true;
        }
    }

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.0012 };
	const animateIn = (node) => {
		const { duration, tickToValue } = springIn(-4, 0, SPRING_IN);
		return {
			duration: 50000,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

    const animateIn2 = (node) => {
		const { duration, tickToValue } = springIn(-10, 0, { stiffness: charged, damping: 0.024 });
		return {
			duration: 1200,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

    const animateIn3 = (node) => {
		const { duration, tickToValue } = springIn(-8, 0, { stiffness: charged, damping: 0.014 });
		return {
			duration: 800,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

    async function autoBattle() {
        display_loading = true;
        await sleep(500);
        restartGame()
        display_loading = false;
    }

    function interate() {
        setTimeout( 
            function() {
                diff_time = Math.floor(Date.now()) - start_time;
                //console.log(diff_time)

                owner_punch = !owner_punch;
                if (!owner_punch) {
                    enemy_punch = !enemy_punch;
                }

                rand_time = Math.floor(Math.random() * 500 + 1);
                energy_used = energy_used + (rand_time/7000)*energy_factor;
                //energy_used = energy_used + energy_factor;
                mebot_cur_dp = mebot_dp - energy_used;
                if (mebot_cur_dp < 0) {
                    mebot_cur_dp = 0;
                }
                daily_power.set(mebot_cur_dp/100);

                enemy_mp = enemy_mp - ((rand_time/7000)*energy_factor/2);
                if (enemy_mp <= 1) {
                    enemy_mp = 0;
                }
                daily_power_enemy.set(enemy_mp/100);

                if (diff_time > me || diff_time > enemy) {
                    owner_punch = false;
                    enemy_punch = false;
                    battle_finished = true;
                    if (me >= enemy) {
                        winner = 2;
                        won_id = owner_mebot_id
                    } else {
                        winner = 1;
                        won_id = enemy_mebot_id
                    }
                    //winnings = enemy_watt_level * factor;
                    winnings = prize;
                    loadGame();

                    if (auto_battle && time_remaining == 0) {
                        autoBattle();
                    }
                    return;
                }
                if (number < 50) {
                    number += 1;
                    interate()
                }
            },
            rand_time
        );
    }

	function doNothing() {
//        charged = 0.0008;
//        visible = !visible

        start_time = Math.floor(Date.now());
        number += 1;
        progress.set(0);
        progress_enemy.set(0);
        interate()

		console.log('do nothing ' + number);
		return;
	}

    async function showBattle() {
        return;
        if (!full_loaded) {
            await sleep(1000);
            doNothing();
            console.log('show battle');
            full_loaded = true;
        }
    }

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

    function moon_phase(phase) {

        switch (phase) {
            case 1: return '🌘'
            case 2: return '🌗'
            case 3: return '🌖'
            case 4: return '🌕'
        }

        return '🌘'
    }

	function displayParsecDetails() {

		displayMebotMessage(`
		<center>
			<br><br>

			` + mebot_power + `

            <br><br>
		</center>`, 30000, 'Ok');
	}

    function displayParsecDetailsEnemy() {

		displayMebotMessage(`
		<center>
			<br><br>

			` + mebot_power_enemy + `

            <br><br><br>
		</center>`, 30000, 'Ok');
	}

    function displayArtifactBlurb(blurb) {

		displayMebotMessage(`
		<center>
			<br>

			` + blurb + `

            <br>
		</center>`, 20000, 'Ok');
    }

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = true
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

    function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

    const preloadImage = src =>
      new Promise((resolve, reject) => {
        const image = new Image()
            image.onload = resolve
            image.onerror = reject
            image.src = src
    })

    function toggleAutobattle () {
		auto_battle = !auto_battle;
	}

	function saveAutobattle () {
		console.log('auto_battle: ' + auto_battle)
		//setCookie("auto_battle", auto_battle, 365);
	}

</script>

<Header
    header_mebot_id = { owner_mebot_id }
	header_dash_token = { dash_token }
/>

<center>
	{#if mebot_img_url && enemy_img_url }

        <center>
            <table width=340px border=0 cellpadding=0>
                <tr height=30px>
                    <td width=120px align=center valign=top on:click={ displayParsecDetailsEnemy }>
                        <table width=90px border=0><tr><td valign=top>

                        {#if enemy_mp > 0 || has_ko == 0}
                        <div style="width: 90px; align: left; margin-top: 8px;">
							<div class="outer_daily_power_enemy">
								<div class="progress_inner_daily_power_enemy" style="width: {$daily_power_enemy * 100}%; margin-top: 5px;" ></div>
							</div>
						</div>
                        {:else}
                        <table width=90px height=10 border=0><tr><td align=center>
                                <div class="vitals_bold text-electric" style="font-size: 14px; margin-bottom: 0px; color: white;"><b>KO'd!</b></div>
                        </td></tr></table>
                        {/if}

                        </td></tr></table>
                    </td>
                    <td width=100px align=center valign=top> <div class="text-electric" style="font-size: 12px; margin-top: 2px;"> ✨{ numberWithCommas(prize) } &nbsp;&nbsp; </div>  </td>
                    <td width=120px align=center valign=top on:click={ displayParsecDetails }>
                        <table width=90px><tr><td valign=top>
                        <div style="width: 90px; margin-top: 8px;">
							<div class="outer_daily_power">
								<div class="progress_inner_daily_power" style="width: {$daily_power * 100}%; margin-top: 5px;" ></div>
							</div>
						</div>
                        </td></tr></table>
                    </td>
                </tr>
                <tr height=130px>
                    <td height=130px width=120px valign=middle align=center>
                        <div in:fade|local={{duration: 450}} class:info-pulsing-zombie={ ( enemy_punch ) }>
                            {#key number}
                            <img in:animateIn2
                                src={enemy_img_url}
                                width="120px"
                                height="120px"
                                alt="meebot"
                                style="user-select: none;"
                                on:load|once={ showBattle }
                                on:click={ punchEnemy }
                            />
                            {/key}
                        </div>
                        {#if enemy_mebot.m_a != '' }

                        <div on:click={ displayArtifactBlurb(enemy_mebot.a_b_abbrev) }>
                        {#if enemy_mebot.m_a != '- - - -' }
                        <div class="text-electric" style="width: 100%; font-size: 14px; display: flex; align-items:center; justify-content: center;">
                            {#each enemy_mebot.m_aa as artifact, i}
                            <span style="display: inline;" class:info-pulsing-zombie-big={ ( artifact.em != '-' && ( (enemy_punch && i == 0) || (owner_punch && i == 1) ) ) }> { artifact.em } </span> &nbsp;
                            {/each}
                        </div>
                        {:else}
                        <div class="text-electric-grey1" style="font-size: 14px;">
                            { enemy_mebot.m_a }
                        </div>
                        {/if}
                        </div>

                        <!--<div class="text-electric" style="font-size: 14px;"> { enemy_mebot.m_a } </div>-->
                        {:else}
                        <div class="text-electric" style="font-size: 14px;"> &nbsp; </div>
                        {/if}
                        <br>
                    </td>
                    <td width=100px align=center><div>
                    <span class="text-electric" style="font-size: 28px;">
                    <br>
                        <img src="https://steps.forever.today/images/7808ba0cfbe0ec15320a80d73d88218e-svg.png" style="margin-top: 0px; margin-bottom: 4px; padding-left: 2px;" width=30px height=30px alt=''>
                    <br>&nbsp;<br><br>
                    </span></div></td>
                    <td height=130px width=120px valign=middle align=center>
                        <div in:fade|local={{duration: 600}} on:click={ null } class:info-pulsing-zombie={ ( owner_punch ) }>
                            {#key number}
                            <img in:animateIn3
                                src={mebot_img_url}
                                width="120px"
                                height="120px"
                                alt="meebot"
                                style="user-select: none; align-items: flex-end;"
                                on:click={ punchMe }
                            />
                            {/key}
                        </div>
                        {#if mebot.m_a != '' }

                        <div on:click={ displayArtifactBlurb(mebot.a_b) }>
                        {#if mebot.m_a != '- - - -' }
                        <div class="text-electric" style="width: 100%; font-size: 14px; display: flex; align-items:center; justify-content: center;">
                            {#each mebot.m_aa as artifact, i}
                            <span style="display: inline;" class:info-pulsing-zombie-big={ ( artifact.em != '-' && ( (owner_punch && i == 0) || (enemy_punch && i == 1) ) ) }> { artifact.em } </span> &nbsp;
                            {/each}
                        </div>
                        {:else}
                        <div class="text-electric-grey1" style="font-size: 14px;">
                            { mebot.m_a }
                        </div>
                        {/if}
                        </div>
                        <!--<div class="text-electric" style="font-size: 10px;">🗜️ 🧰 ⚙️  📎 <div class:info-pulsing-zombie-big={ ( owner_punch ) }>🛠</div> </div>-->
                        <!--<div class="text-electric" style="font-size: 14px;" class:info-pulsing-zombie-big={ ( owner_punch && mebot.m_a != '----' ) }> { mebot.m_a } </div>-->
                        {:else}
                        <div class="text-electric" style="font-size: 14px;"> &nbsp; </div>
                        {/if}
                        <br>
                    </td>
                </tr>
<!--                <tr><td align=center>
                    <div on:click={ displayArtifactBlurb(enemy_mebot.a_b) } style="font-size: 10px;" class="text-blue">{ enemy_mebot.bas }<br><br></div>
                </td><td>
                </td><td align=center>
                    <div on:click={ displayArtifactBlurb(mebot.a_b) } style="font-size: 10px;" class="text-blue">{ mebot.bas }<br><br></div>
                </td></tr>
                <tr><td colspan=3><hr width=60% class="text-blue-light"></td></tr>-->
                <tr height=50px>
                    <td height=65px width=120px valign=bottom align="center">
                        {#if battle_finished && winnings > 0 }
                        {#if winner == 1 }
                        <span in:fade|local={{duration: 450}} class="text-electric" style="margin-top: 12px; font-size: 22px;">&nbsp; 🏆 <br>
                            <span style="font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp; +{ numberWithCommas(winnings) } &nbsp;&nbsp;</span>
                        </span>
                        {:else if winner == 2 }
                        <div in:fade|local={{duration: 450}} class="text-electric-grey" style="margin-top: 12px; margin-bottom: 12px; font-size: 10px;"> &nbsp; ❌ &nbsp;
                        </div>
                        {/if}
                        {:else}
                        <span in:fade|local={{duration: 450}} class="text-electric1" style="margin-top: 12px;">&nbsp; 🎲 <br>
                            <span class="text-electric" style="font-size: 12px;">&nbsp;&nbsp; {dice_enemy}</span>
                        </span>
                        {/if}
                        <br>
                    </td>
                    <td width=100px align=center valign=bottom>
                        <div>
                            {#if balance != 0}
                            <span in:fade|local={{duration: 450}} class="text-electric-white" style="margin-top: 10px;">
                                <!--<div style="font-size: 12px; white-space: nowrap;">✨</div>-->
                                <div style="font-size: 18px; white-space: nowrap;">
                                {#if balance > 0}+{/if}{ numberWithCommas(balance) }
                                </div>
                            </span>
                            {:else}
                            <span in:fade|local={{duration: 450}} class="text-electric-white" style="margin-top: 10px;">
                                <span style="font-size: 12px; white-space: nowrap;"> ⚪ </span>
                            </span>
                            {/if}
                        </div>
                    </td>
                    <td height=65px width=120px valign=bottom align="center">
                        {#if battle_finished && winnings > 0}
                        {#if winner == 2 }
                        <span in:fade|local={{duration: 450}} class="text-electric" style="margin-top: 12px; font-size: 22px;"> 🏆 <br>
                            <span style="font-size: 14px;">&nbsp; +{ numberWithCommas(winnings) } &nbsp;&nbsp;</span>
                        </span>
                        {:else if winner == 1 }
                        <span in:fade|local={{duration: 450}} class="text-electric-grey" style="margin-top: 12px; font-size: 10px;">
                            <span style="font-size: 14px;">&nbsp; -{ numberWithCommas(winnings) } &nbsp;&nbsp;</span>
                        </span>
                        {/if}
                        {:else}
                        <span in:fade|local={{duration: 450}} class="text-electric1" style="margin-top: 12px;"> 🎲 <br>
                            <span class="text-electric" style="font-size: 12px;"> {dice_me}</span>
                        </span>
                        {/if}
                        <br>
                    </td>
                </tr>
                <tr><td colspan=3><hr width=30% class="text-blue-light"></td></tr>
                <tr>
                    <td width=120px valign=middle align=right>
                        <table border=0>
                            <!--<tr><td width=90px>
                                <div class="outer"><div class="progress_inner_enemy" style="width: {$progress * 100}%"></div></div>
                                </td>
                            </tr>-->
                        <tr>
                        <td width=85px>
                        <div in:fade|local={{duration: 450}} style="white-space: nowrap;" on:click={ displayArtifactBlurb(enemy_mebot.a_b_abbrev) }>
                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> ⚔️ &nbsp;</span></span>
                            <span class="text-glow-blue" style="margin-top: 10px; font-size: 18px;">{ enemy_mebot.bas } &nbsp; </span><br>

<!--                            <span class="text-electric" style="color:silver; margin-top: 0px; "><span class="text-electric-yellow" style="opacity: 0;"> ⚡ &nbsp;</span></span>
                            <span class="text-electric-yellow" style="color:silver; margin-top: 10px; font-size: 12px;"> Lvl <span class="text-electric">{ enemy_mebot.watt_level }</span></span><br>-->
                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 〰️ &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ enemy_mebot.class }</span><br>
                            <!--<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 🎮 &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ enemy_mebot.experience }</span><br>-->
                            <!--<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> { enemy_mebot.mood.em } &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;"> { enemy_mebot.mp_days }`{ enemy_mebot.parsecs }</span><br>-->
<!--                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 🏃 &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ (enemy_mebot.uhv == 0 ? '-' : enemy_mebot.uhv) }</span><br>-->
                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 👟 &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ (enemy_mebot.steps_14day_av == 0 ? '0.1k' : enemy_mebot.steps_14day_av_info) }</span><br>
                        </div>
                        <div style="margin-top: 10px;">
                        <Line style="background:#7f7f7f; background:rgba(0,0,0,0.15); border-radius: 4px; padding: 5px; padding-top: 8px;" data={data_1} height={15} width={60} options={
                            {
                                responsive: false,
                                maintainAspectRatio: false,
                                plugins: { legend: false, tooltip: false },
                                scales: { x: {display: false, grid: {display: false}}, y: {display: false, max: 11000, grid: {display: false}} }
                            }
                        }
                        />
                        </div>
                        </td>
                        </tr>
                        </table>
                    </td>
                    <td width=100px align=center valign=bottom><div><span class="text-electric" style="font-size: 30px;"><br></span></div>
                        {#if false && time_remaining == 0 && battle_finished}
                        <span on:click={restartGame} class="vitals_bold text-electric" style="font-size: 40px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">&#8634;</span>
                        {/if}
                    </td>
                    <td width=120px valign=middle align=right>
                        <table border=0>
                            <!--<tr><td width=90px>
                                <div class="outer"><div class="progress_inner_enemy" style="width: {$progress * 100}%"></div></div>
                                </td>
                            </tr>-->
                        <tr>
                        <td width=90px>
                        <div in:fade|local={{duration: 600}} style="white-space: nowrap;" on:click={ displayArtifactBlurb(mebot.a_b) }>
<!--                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> ⚡ &nbsp;</span></span>
                            <span class="text-electric-white text-green" style="margin-top: 10px; font-size: 22px;">{ mebot.fitness } &nbsp; </span><br>-->
                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> ⚔️ &nbsp;</span></span>
                            <span class="text-glow-blue" style="margin-top: 10px; font-size: 18px;">{ mebot.bas } &nbsp; </span><br>

<!--                            <span class="text-electric" style="color:silver; margin-top: 0px; "><span class="text-electric-yellow" style="opacity: 0;"> ⚡ &nbsp;</span></span>
                            <span class="text-electric-yellow" style="color:silver; margin-top: 10px; font-size: 12px;"> Lvl <span class="text-electric">{ mebot.watt_level }</span></span><br>-->
                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 〰️ &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ mebot.class }</span><br>
                            <!--<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 🎮 &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ mebot.experience }</span><br>-->
                            <!--<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> { mebot.mood.em } &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ mebot.mp_days }`{ mebot.parsecs }</span><br>-->
<!--                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 🏃 &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ (mebot.uhv == 0 ? '-' : mebot.uhv) }</span><br>-->
                            <span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"> 👟 &nbsp;</span></span>
                            <span class="text-electric-white" style="margin-top: 10px;">{ (mebot.steps_14day_av == 0 ? '0.1k' : mebot.steps_14day_av_info) }</span><br>
                        </div>
                        <div style="margin-top: 10px;">
                            <Line style="background:#7f7f7f; background:rgba(0,0,0,0.15); border-radius: 4px; padding: 5px; padding-top: 8px;" data={data_2} height={15} width={60} options={
                                {
                                    responsive: false,
                                    maintainAspectRatio: false,
                                    plugins: { legend: false, tooltip: false },
                                    scales: { x: {display: false, grid: {display: false}}, y: {display: false, max: 11000, grid: {display: false}} }
                                }
                            }
                            />
                        </div>
                        </td>
                        </tr>
                        </table>
                    </td>
                </tr>
                {#if !battle_finished }
                <tr>
                <td width=120px valign=middle align=middle> <table width=80px border=0><tr><td> <div class="outer"><div class="progress_inner_enemy" style="width: {$progress_enemy * 100}%"></div></div> </td></tr></table> </td>
                <td width=80px align=center>
                            <div class="text-electric info" style="white-space: nowrap; margin-top: 14px; font-size: 12px;" >Auto ⚔️</div>
                            <div class="text-electric info" style="white-space: nowrap;" >
                                <Switch bind:checked={auto_battle}></Switch>
                            </div>
                </td>
                <td width=120px valign=middle align=middle> <table width=80px border=0><tr><td> <div class="outer"><div class="progress_inner" style="width: {$progress * 100}%"></div></div> </td></tr></table>
                </td>
                </tr>
                {:else }
                <tr><td colspan=3 align=center valign=top height="20px">
                {#if time_remaining == 0 && battle_finished}

                {#if display_loading == true }
                <div on:click={restartGame} class="vitals_bold text-electric" style="font-size: 12px; margin-top: 18px;">Loading...</div>
                {:else }
                <span on:click={restartGame} class="vitals_bold text-electric" style="font-size: 50px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">&#8634;</span>
                {/if}

                {:else if time_remaining > 0 && battle_finished}
                <span on:click={ displayParsecDetails } class="vitals_bold text-electric" style="font-size: 12px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">
                    {@html no_energy }
                </span>
                {/if}
                </td></tr>
                {/if}
            </table>
        </center>

	{:else}
    <div class="snake_row">
    </div>
	{/if}

	<div class="small_row">
	</div>

</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>
	
	.snake_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		justify-content: center;
		margin-bottom: 10px;
	}
	.small_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		margin-bottom: 10px;
		margin-left: 40px;
		margin-right: 30px;
	}

	img {
		max-height: 90%;
	}

    .progress_inner, .progress_inner_enemy, .outer {
	    height: 2px;
	    border-radius: 0px;
    }

    .progress_inner {
	    background-color: #b3f8f5;
	    display: block;
	    box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
    }

    .progress_inner_enemy {
		background-color: rgb(114, 92, 216);
		display: block;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
	}

	.text-glow {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: white;
	}

    .text-electric {
        font-size: 14px;
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}

    .text-electric-white {
        font-size: 14px;
		text-shadow: 0 0 5px rgba(253, 253, 253, 0.9),
			0 0 8px rgba(252, 252, 252, 0.98);
		font-family: arial;
		color: hsl(60, 19%, 88%);
	}
    .text-electric-grey {
        font-size: 14px;
		text-shadow: 0 0 5px rgba(151, 151, 151, 0.9),
			0 0 8px rgba(180, 17, 17, 0.98);
		font-family: arial;
		color: hsl(0, 99%, 39%);
	}
    .text-electric-grey1 {
        font-size: 14px;
		text-shadow: 0 0 5px rgba(151, 151, 151, 0.9),
			0 0 8px rgba(187, 187, 187, 0.98);
		font-family: arial;
		color: hsla(0, 0%, 84%, 0.579);
	}

    .text-green {
        color: #1bffe8ee;
    }

    .text-blue {
		color: #00cafd;
	}
    .text-glow-blue {
        text-shadow: 0 0 10px #00cafd,
            0 0 32px rgb(65 120 255 / 88%);
        font-family: arial;
        color: #00cafd;
    }
    .text-blue-light {
        border: 0;
        height: 1px;
        background-image: linear-gradient(to right, #00cafd00, #00cafd9e, #00cafd00);
	}

	.text-glow-electric {
		text-shadow: 0 0 10px rgba(64, 255, 249, 0.75),
			0 0 32px rgba(65, 246, 255, 0.88);
		font-family: arial;
		color: rgb(156, 255, 250);
	}

	.vitals2-grey {
		color: rgb(242, 248, 247);
		font-size: 14px;
	}

	.vitals2 {
		color: white;
		font-size: 14px;
	}

	.controls {
		margin-bottom: 15px;
	}

	.mebot_active1 {
        border-radius: 15px;
        box-shadow: 0 3px 7px rgb(231, 247, 255);

        background: linear-gradient(114deg, #ffffff, #725cd8, #42e3ff, #42e3ff);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 6s ease infinite;
		-moz-animation: AnimationName 6s ease infinite;
		-o-animation: AnimationName 6s ease infinite;
		animation: AnimationName 6s ease infinite;
	}

    @-webkit-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}

	.no_tap_zoom {
		touch-action: manipulation;
	}

	.like-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.5s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.hand-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.4s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

    .info-pulsing-zombie {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.2s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	10% {
		transform: scale(1.1);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}
	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

    .info-pulsing-zombie-big {
		font-weight: bold;
		transform: scale(5);
		animation: zombie-fight-big 0.2s infinite;
	}
	@keyframes zombie-fight-big {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	10% {
		transform: scale(1.9);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}
	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}
	.outer_daily_power{
		margin: 0px;
		background-color: transparent;
		border: 0px;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner_daily_power {
		background-color: #1bffe8ee;
		display: block;
		box-shadow: 0 0 8px rgb(255, 255, 0), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}

	.outer_daily_power_enemy{
		margin: 0px;
		background-color: transparent;
		border: 0px;
		box-shadow: 0 0 8px rgb(255, 0, 0), 0 0 12px rgb(255, 191, 191);
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner_daily_power_enemy {
		background-color: #ff0000;
		display: block;
		box-shadow: 0 0 8px rgb(208, 69, 69), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}

</style>